import React, { FunctionComponent } from 'react';
import { Eyebrow } from '@companion-professional/components';

interface DetailRowProps {
  label: string;
  children: React.ReactNode;
}

// DetailRow is a component that shows a label and a value in the grid layout inside the CheckupDetails component.
export const DetailElement: FunctionComponent<DetailRowProps> = ({ children, label }) => {
  return (
    <>
      <Eyebrow tone="muted" className="flex h-8 items-center overflow-ellipsis">
        {label}
      </Eyebrow>
      <div className="flex items-center">{children}</div>
    </>
  );
};
